<template>
  <div v-if="parents && section">
    <h1>
      <span>Section</span>
      <span v-if="$route.params.id">&#160;({{ section.xmlTag }})</span>
    </h1>
    <v-btn
      :to="{
        name: 'quoteScript',
        params: {
          id: computedQuotescriptid
        }
      }"
    >
      <v-icon>chevron_left</v-icon>Quote script
    </v-btn>
    <div v-if="!$route.params.id">
      <v-select
        label="Xml tag"
        v-model="xmlTag"
        :items="xmlTags"
        item-value="id"
        item-text="name"
        outline
      />
      <v-btn @click="saveSection"> <v-icon>save</v-icon>Save </v-btn>
    </div>
    <div v-if="$route.params.id">
      <h3>Rule sets</h3>
      <v-btn @click="showRuleset = true" v-if="!showRuleset">
        <v-icon>add</v-icon>Rule set
      </v-btn>
      <div v-if="showRuleset" class="ajaxForm">
        <v-form ref="rulesetForm">
          <v-text-field
            label="Heading"
            v-model="heading"
            outline
            :rules="valueRules"
          />
          <v-btn @click="createRuleset">Save</v-btn>
          <v-btn @click="showRuleset = false">Cancel</v-btn>
        </v-form>
      </div>
      <v-data-table
        hide-actions
        :headers="computedHeaders"
        :items="ruleSets"
        class="elevation-1"
        v-if="ruleSets"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-btn
                small
                :to="{
                  name: 'quoteRuleSet',
                  params: { id: props.item.id }
                }"
                >{{ props.item.id }}</v-btn
              >
            </td>
            <td>{{ props.item.heading }}</td>
            <td v-if="!parents.quoteScript.published">
              <v-btn @click="moveRuleSet(props.item, true)" small>
                <v-icon>arrow_upward</v-icon>
              </v-btn>
              <v-btn @click="moveRuleSet(props.item, false)" small>
                <v-icon>arrow_downward</v-icon>
              </v-btn>
              <v-btn @click="deleteRuleSet(props.item)" color="error" small>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Section",
  metaInfo() {
    return {
      title: "Section",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedQuotescriptid() {
      if (this.$route.query.quotescriptid) {
        return this.$route.query.quotescriptid;
      }
      if (!this.section) {
        return undefined;
      }
      return this.section.quotescriptid;
    },
    computedHeaders() {
      let headers = [
        {
          text: "Id",
          sortable: false
        },
        {
          text: "Heading",
          sortable: false
        }
      ];
      if (!this.parents.quoteScript.published) {
        headers.push({
          text: "Options",
          sortable: false
        });
      }
      return headers;
    }
  },
  data() {
    return {
      section: null,
      parents: null,
      ruleSets: null,
      xmlTags: [
        { id: "costs", name: "Costs" },
        { id: "disbursements", name: "Disbursements" },
        { id: "searches", name: "Searches" }
      ],
      xmlTag: "costs",
      showRuleset: false,
      heading: null,
      valueRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchSection() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/sections/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.section = response.data;
    },
    async fetchParents() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/sections/${this.$route.params.id}/parents`
      );
      // console.log(response.data);
      this.parents = response.data;
    },
    async fetchRuleSets() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/sections/${this.$route.params.id}/rulesets`
      );
      // console.log(response.data);
      this.ruleSets = response.data;
    },
    async moveRuleSet(ruleset, up) {
      await nbmlaw.put(
        `/cors/admin/sales/sections/${this.$route.params.id}/rulesets/${ruleset.id}/move`,
        null,
        { params: { up } }
      );
      // console.log(response.data);
      this.fetchRuleSets();
    },
    async deleteRuleSet(rule) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/sales/rulesets/${rule.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    async createRuleset() {
      if (this.$refs.rulesetForm.validate()) {
        const response = await nbmlaw.post(
          `/cors/admin/sales/sections/${this.$route.params.id}/rulesets`,
          { heading: this.heading }
        );
        // console.log(response.data);
        this.$router.push({
          name: "quoteRuleSet",
          params: {
            id: response.data
          }
        });
      }
    },
    async saveSection() {
      const response = await nbmlaw.post(
        `/cors/admin/sales/quoteScripts/${this.$route.query.quotescriptid}/sections`,
        null,
        { params: { xmlTag: this.xmlTag } }
      );
      // console.log(response.data);
      this.$router.push({
        name: "quoteSection",
        params: {
          id: response.data
        }
      });
    },
    update() {
      this.fetchSection();
      this.fetchParents();
      this.fetchRuleSets();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.update();
        } else {
          this.section = {};
        }
      }
    }
  }
};
</script>